var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2885 1.97204C18.081 1.20094 17.473 0.593122 16.7021 0.385481C15.2935 0 9.65919 0 9.65919 0C9.65919 0 4.02501 0 2.61643 0.370787C1.8603 0.578291 1.23752 1.20108 1.03001 1.97204C0.659363 3.38048 0.659363 6.30146 0.659363 6.30146C0.659363 6.30146 0.659363 9.23713 1.03001 10.6309C1.23765 11.4018 1.84547 12.0098 2.61657 12.2174C4.03984 12.6029 9.65933 12.6029 9.65933 12.6029C9.65933 12.6029 15.2935 12.6029 16.7021 12.2321C17.4732 12.0246 18.081 11.4167 18.2886 10.6457C18.6593 9.23713 18.6593 6.31629 18.6593 6.31629C18.6593 6.31629 18.6741 3.38048 18.2885 1.97204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8653 8.99994L12.5506 6.30142L7.8653 3.60291V8.99994Z",
    fill: "#ED2224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtFoot);
export default __webpack_public_path__ + "static/media/yt-foot.eeaf633a290566bddba823ae1b533c6e.svg";
export { ForwardRef as ReactComponent };